export default __webpack_public_path__ + "static/media/med.e3d8425f.jpg";